import React from 'react'
import { css } from 'linaria'

const DEFAULT_AVATARS_IMAGE =
   'https://cdn.gamifiera.com/static/1220/upl/cTnlXkquYRpk1qG2.1.webp'

const avatarsWrap = css`
   overflow: hidden;
   width: 100%;
   margin: 0 0 1.25rem;
   position: relative;

   -webkit-mask-image: linear-gradient(
      to right,
      transparent,
      #000 10%,
      #000 90%,
      transparent
   );
   mask-image: linear-gradient(
      to right,
      transparent,
      #000 10%,
      #000 90%,
      transparent
   );
   -webkit-mask-size: 100% 100%;
   mask-size: 100% 100%;
   -webkit-mask-repeat: no-repeat;
   mask-repeat: no-repeat;
`

const avatarsImg = css`
   display: block;
   width: 122%;
   max-width: none;
   height: auto;
   margin: 0;
   margin-left: -11%;
   /* Crop baked-in top padding in the asset; wrapper clips overflow. */
   margin-top: -9%;
`

export default function GamifieraAvatars({
   src = DEFAULT_AVATARS_IMAGE,
   alt = '',
   className,
}) {
   if (!src) return null

   return (
      <div className={`${avatarsWrap}${className ? ` ${className}` : ''}`}>
         <img
            className={avatarsImg}
            src={src}
            alt={alt}
            loading="eager"
            decoding="async"
         />
      </div>
   )
}
